import { View, Image, Text, Button, Heading } from '@aws-amplify/ui-react'
import { useTheme, useAuthenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'

import '../index.css'


/**
 * Used to overwrite default Cognito components.
 * Ref: https://ui.docs.amplify.aws/react/connected-components/authenticator/customization
 */
export const cognitoComponents = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View 
        textAlign="center" 
        padding={tokens.space.large}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Image  
          src="https://media-monitoring-assets.s3.amazonaws.com/fcc-seal-rgb-2020-80x80.png"
          style={{ marginRight: '12px', width: '60px', height: '60px' }}
          alt="FCC Logo"
        />
        <h4 style={{ margin: 0 }}>FCC Media Analysis Archive</h4>
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text 
          color={tokens.colors.neutral[90]}
          style={{ paddingTop: '4px' }}>
            Note that this is a private website which requires that you 
            (a) provide a valid email address and 
            (b) be a designated user by the Federal Communications Commission. 
            Note that this website will automatically discard registration requests from unknown users.
        </Text>
        <Text 
          color={tokens.colors.neutral[80]}
          style={{ paddingTop: '40px' }}>
            &copy; {new Date().getFullYear()} - Powered by Barbaricum, LLC
        </Text>
      </View>
    );
  },

  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Sign in to your account
        </Heading>
      );
    },
    Footer() {
      const authState = useAuthenticator()
      const { toResetPassword } = authState

      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toResetPassword}
            size="small"
            variation="link"
          >
            Reset Password
          </Button>
        </View>
      );
    },
  },

  SignUp: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Create a new account
        </Heading>
      );
    },
    Footer() {
      const { toSignIn } = useAuthenticator();

      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toSignIn}
            size="small"
            variation="link"
          >
            Back to Sign In
          </Button>
        </View>
      );
    },
  },
  ConfirmSignUp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  SetupTotp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  ConfirmSignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  ForgotPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
  ConfirmResetPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Enter Information:
        </Heading>
      );
    },
    Footer() {
      return <Text></Text>;
    },
  },
};

